export interface Bonus {
  id: string
  title: string
  subtitle: string
  intro?: string
  bulletsIntro?: string
  bullets?: string[]
  secondaryBulletsIntro?: string
  secondaryBullets?: string[]
  systemLabel?: string
  system?: string
  closing?: string[]
}

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: 'Flight Instructor Cueing & Error Correction Handbook',
    subtitle: 'See the mistake. Understand the cause. Give the right correction.',
    intro:
      'A practical instructor reference designed to help you identify common student problems and respond with clearer teaching cues.',
    systemLabel: 'Core system:',
    system: 'ERROR → CAUSE → CUE → CORRECTION → RETRY',
    closing: ['Stop simply saying: “Try again.”', 'Start giving your student a clearer correction.'],
  },
  {
    id: '2',
    title: '100 Flight Training Drills, Scenarios & Student Challenges',
    subtitle: 'Ready-to-use practice activities for real flight training.',
    bulletsIntro: 'Includes practical drills and scenarios for:',
    bullets: [
      'Aircraft control',
      'Patterns',
      'Takeoffs',
      'Landings',
      'Navigation',
      'Communication',
      'Decision-making',
      'Awareness',
      'Precision',
      'Confidence',
      'Student independence',
    ],
    closing: [
      'Use them whenever a student needs additional practice without having to create another activity yourself.',
    ],
  },
  {
    id: '3',
    title: 'Student Pilot Assessment & Progress Tracking System',
    subtitle: 'Know where your student is — and what they should work on next.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Skill assessments',
      'Student profiles',
      'Lesson records',
      'Visual rubrics',
      'Progress checklists',
      'Readiness indicators',
      'Independence tracking',
      'Next-lesson objectives',
      'Student development records',
    ],
    secondaryBulletsIntro: 'Simple progress scale:',
    secondaryBullets: [
      '1 — Needs Full Support',
      '2 — Developing',
      '3 — Controlled',
      '4 — Independent',
    ],
  },
  {
    id: '4',
    title: 'Flight Lesson Planning & Sequencing System',
    subtitle: 'Build stronger lesson progression without starting from zero.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Lesson structures',
      'Beginner pathways',
      'Developing-student pathways',
      'Checkride-ready pathways',
      'Skill sequencing',
      'Training progressions',
      'What-to-teach-next decision tools',
    ],
    systemLabel: 'Core flow:',
    system: 'ASSESS → CHOOSE → TEACH → PRACTICE → CHECK → PROGRESS',
  },
  {
    id: '5',
    title: 'Flight Training Troubleshooting & Problem-Solving Manual',
    subtitle: 'See the problem. Find the root cause. Apply the fix.',
    intro: 'A practical visual diagnostic reference for common training problems.',
    systemLabel: 'Core system:',
    system: 'SEE PROBLEM → FIND ROOT CAUSE → APPLY FIX → PRACTICE → RECHECK',
    closing: [
      "Instead of repeatedly treating the symptom, identify what is actually causing the student's difficulty.",
    ],
  },
]
